import SmartMeetingRoomBooking from './SmartMeetingRoomBooking';

export default SmartMeetingRoomBooking;
